import { useEffect, type ReactNode } from 'react';

import { cn } from '~/utils/cn';

interface PropsBackdrop {
  open: boolean;
  onClose?: () => void;
  children: ReactNode;
  className?: string;
  position?: 'center' | 'bottom';
}

export default function Backdrop({
  open,
  onClose,
  children,
  className,
  position = 'center',
}: PropsBackdrop) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', handler);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', handler);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className={cn(
        'fixed inset-0 z-50 bg-black/60 flex animate-fade_in',
        position === 'bottom' ? 'items-end justify-center' : 'items-center justify-center p-medium',
      )}
      onClick={onClose}
    >
      <div
        className={cn(
          'bg-intense-01',
          position === 'center'
            ? 'rounded-large max-w-[440px] w-full'
            : 'rounded-t-large w-full max-w-[640px]',
          className,
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
